import React, { useEffect, useState, useRef } from 'react';
import AdminLayout from '../../Componets/AdminLayout';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export default function Add() {
  const apiUrl = process.env.REACT_APP_API_URL;
  const navigate = useNavigate();
  const [loaded, setLoaded] = useState(false);
  const [selectionType, setSelectionType] = useState('one');
  const [formData, setFormData] = useState({
    objectiveName: '',
  });
  const focusInputRef = useRef(null);
  const location = useLocation();
  const currentPath = location?.pathname || '';
  const token = localStorage.getItem('token');

  useEffect(() => {
    const role = localStorage.getItem('role');
    if (role !== 'ADMIN') {
      navigate('/');
    }
    if (focusInputRef.current) {
      focusInputRef.current.focus();
    }
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoaded(true);

    axios
      .post(`${apiUrl}/api/subject-objective/`, formData, {
        headers: {
          Authorization: `${token}`,
        },
      })
      .then((res) => {
        toast.success('Subject Objective added successfully');
        setLoaded(false);
        setFormData({ objectiveName: '' });
        if (focusInputRef.current) {
          focusInputRef.current.focus();
        }
        if (selectionType === 'one' && currentPath === '/ObjectiveAdd') {
          const timeoutId = setTimeout(() => {
            if (window.location.pathname === '/ObjectiveAdd') {
              navigate('/ObjectiveList');
            }
          }, 3000);
          return () => clearTimeout(timeoutId);
        }
      })
      .catch((err) => {
        toast.error(err.response?.data?.message);
        if (err.response?.status === 401) navigate('/');
        setLoaded(false);
      });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  return (
    <>
      <AdminLayout ac14="active" dr="true">
        <main id="main" className="main">
          <div className="pagetitle">
            <nav>
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/AdminHome">Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/ObjectiveList">View Subject Objectives</Link>
                </li>
                <li className="breadcrumb-item active">
                  Add New Subject Objectives
                </li>
              </ol>
            </nav>
          </div>
          <section className="section col-lg-112">
            <div className="row">
              <div className="">
                <div className="card">
                  <div className="card-body mt-5 mx-3">
                    <form onSubmit={handleSubmit}>
                      <div className="container">
                        <div className="row row-cols-1">
                          <div className="col-12">
                            <div className="form-floating mb-2">
                              <input
                                ref={focusInputRef}
                                className="form-control"
                                type="text"
                                name="objectiveName"
                                value={formData.objectiveName}
                                onChange={handleChange}
                                placeholder="Name"
                                required
                              />
                              <label htmlFor="txtGrNo">
                                Subject Objectives Name{' '}
                                <span className="text-danger">*</span>
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="d-flex justify-content-between">
                          <div className="p-2 mx-2 bd-highlight">
                            <div className="form-check form-switch">
                              <input
                                className="form-check-input recode-switch"
                                type="checkbox"
                                id="selectionSwitch"
                                checked={selectionType === 'many'}
                                onChange={() =>
                                  setSelectionType(
                                    selectionType === 'many' ? 'one' : 'many'
                                  )
                                }
                              />
                              <label
                                className="form-check-label"
                                htmlFor="selectionSwitch"
                              >
                                {selectionType === 'many'
                                  ? 'Many Subject Objectives Add'
                                  : 'One Subject Objectives Add'}
                              </label>
                            </div>
                          </div>
                          <div className="p-2 mx-1 bd-highlight">
                            <button
                              type="button"
                              className="btn btn-primary px-3"
                              onClick={() => navigate(-1)}
                            >
                              <i className="bi bi-arrow-bar-left"></i> Back
                            </button>
                            <button
                              type="submit"
                              className="btn btn-primary px-4 mx-1"
                              disabled={loaded}
                            >
                              {loaded ? (
                                <>
                                  <span
                                    className="spinner-border spinner-border-sm"
                                    role="status"
                                    aria-hidden="true"
                                  ></span>{' '}
                                  Wait...
                                </>
                              ) : (
                                <>Save</>
                              )}
                            </button>
                          </div>
                        </div>
                      </div>
                    </form>
                    <ToastContainer
                      position="top-center"
                      style={{ width: 'auto' }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </section>
        </main>
      </AdminLayout>
    </>
  );
}
